module.exports = __webpack_public_path__ + "media/images/print-9d28fb7807151c474599975a1313e04d.svg";